document.addEventListener('DOMContentLoaded', function () {
  const loginButton = document.getElementById('login_button')
  const loginUsername = document.getElementById('username')
  const loginPassword = document.getElementById('password')

  const registerButton = document.getElementById('register_button')
  const registerUsername = document.getElementById('reg_username')
  const registerEmail = document.getElementById('reg_email')
  const registerPassword = document.getElementById('reg_password')

  function toggleButtonState(button, ...fields) {
    const allFilled = fields.every(
      (field) => field && field.value.trim() !== ''
    )
    button.disabled = !allFilled
  }

  if (loginButton && loginUsername && loginPassword) {
    loginUsername.addEventListener('input', () =>
      toggleButtonState(loginButton, loginUsername, loginPassword)
    )
    loginPassword.addEventListener('input', () =>
      toggleButtonState(loginButton, loginUsername, loginPassword)
    )
  }

  if (registerButton) {
    const registerFields = [registerEmail, registerPassword]
    if (registerUsername) registerFields.push(registerUsername)

    registerFields.forEach((field) => {
      if (field) {
        field.addEventListener('input', () =>
          toggleButtonState(registerButton, ...registerFields)
        )
      }
    })
  }
})
